export const CHECKOUT_URL = 'https://unstuck6v.impultienda.ar/checkout'

export const MAIN_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/nWg4g7YgSenkMfJ34PfxTF/MOCK_UP_GRAL.png'

export const HERO_HEADLINE =
  'Procrastination feels comfortable in the moment. Until you realize what it’s costing you.'

export const HERO_BODY: string[] = [
  'The unfinished projects. The goals you keep postponing. The promises you keep making to yourself.',
  'Waiting for the perfect moment won’t move your life forward.',
]

export const HERO_EMPHASIS = 'Starting will. Finishing will.'

export const HERO_SUB =
  'UNSTUCK Complete System — Dopamine reset + Focus architecture + Execution ready to use.'

/** Launch window, in seconds, counted down from page load. */
export const LAUNCH_WINDOW_SECONDS = 7 * 3600 + 42 * 60 + 15

export const journeySteps: string[] = [
  'Reset',
  'Prioritize',
  'Focus',
  'Energy',
  'Action',
  'Mindset',
]

export type Stat = { value: string; label: string }

export const stats: Stat[] = [
  { value: '+2,000', label: 'People unstuck' },
  { value: '6', label: 'Complete volumes' },
  { value: '5', label: 'Bonus tools included' },
  { value: '4.9/5', label: 'Average rating' },
]

export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'MR',
    quote:
      'I organized my entire year in one afternoon. The system saves me 15 hours every week.',
    name: 'Marcus R.',
    role: 'Entrepreneur',
  },
  {
    initials: 'SC',
    quote:
      'The 90-Second Rule finally works. I actually execute instead of planning.',
    name: 'Sarah C.',
    role: 'Freelancer · Digital Creator',
  },
  {
    initials: 'DP',
    quote:
      'My classes finally flow. The focus framework changed everything.',
    name: 'David P.',
    role: 'Buenos Aires',
  },
]

export type PainLine = { headline: string; detail: string }

export const painLines: PainLine[] = [
  {
    headline: 'Monday morning scrolling for “just 5 minutes”',
    detail: 'Suddenly it’s noon and nothing is done.',
  },
  {
    headline: 'You sit down to work and your mind goes blank',
    detail: 'Resistance everywhere, paralysis sets in.',
  },
  {
    headline: 'Starting 3 projects and finishing absolutely none',
    detail: 'Scattered energy, broken promises to yourself.',
  },
  {
    headline: 'Your brain overstimulated, priorities unclear',
    detail: 'No visual system, just chaos.',
  },
  {
    headline: 'Best mental hours wasted on email and admin',
    detail: 'The busy-work trap. No real progress.',
  },
  {
    headline: 'Weekends exhausted, Monday you restart the cycle',
    detail: 'Nothing changes, nothing moves.',
  },
]

export type Volume = {
  number: string
  title: string
  category: string
  line: string
}

export const volumes: Volume[] = [
  {
    number: 'Volume 1',
    title: 'The Dopamine Reset',
    category: 'Foundation',
    line: 'Reclaim your brain. Reduce overstimulation. Make focus rewarding again.',
  },
  {
    number: 'Volume 2',
    title: 'The Execution Matrix',
    category: 'Strategy',
    line: 'Know exactly what deserves your time. Eliminate busy work forever.',
  },
  {
    number: 'Volume 3',
    title: 'Deep Focus Architecture',
    category: 'Environment',
    line: 'Design your workspace so distractions can’t reach you.',
  },
  {
    number: 'Volume 4',
    title: 'Biological Peak Performance',
    category: 'Energy',
    line: 'Work when your brain is sharpest. Effortless productivity.',
  },
  {
    number: 'Volume 5',
    title: 'The 90-Second Rule',
    category: 'Tactics',
    line: 'Destroy starting resistance. Begin before fear takes control.',
  },
  {
    number: 'Volume 6',
    title: 'The Unstoppable Mindset',
    category: 'Psychology',
    line: 'Break perfectionism, imposter syndrome and self-doubt.',
  },
]

export const systemIncludes: string[] = [
  'Step-by-step implementation protocols',
  'Practical exercises you can apply immediately',
  'Quick-action checklists & action plans',
  'Troubleshooting for common execution roadblocks',
  'Focus, prioritization & execution frameworks',
  'Ready-to-use systems, rituals & protocols',
  'Simple strategies designed for real-world execution',
]

export const INCLUDES_KICKER = 'Less theory. More “what do I do next?”'

export type Bonus = {
  number: string
  title: string
  line: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 10-Minute Focus Reset Checklist',
    line: 'Regain clarity and enter execution mode in under 10 minutes.',
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/d7wtAHe5aRwHT9LdokuWXW/US_BONO_1.png',
  },
  {
    number: '02',
    title: 'The Distraction Firewall Setup',
    line: 'Block your biggest triggers across phone, browser and workspace.',
    value: '$37',
    image:
      'https://cdn.magicpatterns.com/uploads/qGFFddXzhXnZVyUp2MCdoy/US_BONO_2.png',
  },
  {
    number: '03',
    title: 'The 7-Day Execution Sprint Kit',
    line: 'Ready-to-use templates and a repeatable daily rhythm.',
    value: '$29',
    image:
      'https://cdn.magicpatterns.com/uploads/9NV2KLZwFBzPtCxmYC8Gr5/US_BONO_3.png',
  },
  {
    number: '04',
    title: 'The Resistance Breaker Script Pack',
    line: 'Mental scripts to overcome overthinking and perfectionism.',
    value: '$24',
    image:
      'https://cdn.magicpatterns.com/uploads/7UG38XteQChmCMUsTGEhAx/US_BONO_4.png',
  },
  {
    number: '05',
    title: 'The Daily Unstuck Scorecard',
    line: 'Track your focus, execution and follow-through in 3 minutes.',
    value: '$19',
    image:
      'https://cdn.magicpatterns.com/uploads/uP9PKKQyG43JCGi8UkuY2U/US_BONO_5.png',
  },
]

export const BONUS_TOTAL = '$156 USD'

export const offerItems: string[] = [
  '6 Complete Volumes — 340+ pages',
  '5 Strategic Bonuses',
  'Instant digital access in 5 minutes',
  'Lifetime access, on any device',
]

export const pricing = {
  regularPrice: '$97 USD',
  today: '$27',
  afterLaunch: '$47 USD',
  spotsTaken: 72,
  idealFor: 'Everyone ready to execute',
}

export type CostRow = { situation: string; result: string }

export const costRows: CostRow[] = [
  {
    situation: 'Wasting 10+ hours a week',
    result: 'Distraction and fake productivity.',
  },
  {
    situation: 'Projects you never finish',
    result: 'Ideas stuck in your head forever.',
  },
  {
    situation: 'Weekends checking email',
    result: 'Never fully resting, never fully working.',
  },
  {
    situation: 'Starting resistance every day',
    result: 'Hours lost before you even begin.',
  },
  {
    situation: 'Self-doubt and perfectionism ruling you',
    result: 'Never shipping anything good enough.',
  },
  {
    situation: 'The same cycle next year',
    result: 'Nothing changes, nothing moves.',
  },
  {
    situation: 'Your potential unrealized',
    result: 'Another year goes by.',
  },
]

export type Faq = { question: string; answer: string }

export const faqs: Faq[] = [
  {
    question: 'Does it work for severe procrastination?',
    answer:
      'That’s exactly who it was built for. Volume 1 lowers the overstimulation that makes focus feel impossible, and Volume 5 (The 90-Second Rule) removes the starting resistance — so you begin before fear takes control.',
  },
  {
    question: 'How do I receive the material?',
    answer:
      '100% PDF, delivered instantly. You get access within about 5 minutes of checkout, with lifetime access on any device.',
  },
  {
    question: 'What makes it different from online content?',
    answer:
      'Nothing here is theory you still have to assemble. It’s 340+ pages of protocols, checklists, scripts and templates already built — you open it and execute today instead of spending weekends researching.',
  },
  {
    question: 'Is the guarantee real?',
    answer:
      'Yes. Open the volumes, use them in your life, and if within 7 days it isn’t what you expected you get a 100% refund — no forms, no drama. Our return rate is under 1%.',
  },
]

export const footerLinks = {
  email: 'support@redondoland.com',
  social: '@redondoland',
  website: 'www.redondoland.com',
}

export type PurchaseNotice = { name: string; location: string; minutesAgo: number }

export const purchaseNotice: PurchaseNotice = {
  name: 'Marcus R.',
  location: 'New York',
  minutesAgo: 4,
}

export const CLOSING_LINE = 'The next week can be different.'
